// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--iLbyb","icon":"_4f720283bf--icon--plHr9","desktop":"_4f720283bf--desktop--fCYzf","mobile":"_4f720283bf--mobile--aUIpf"};